export default {
  bind(el, binding, vnode) {
    const input =
      el.querySelector(".el-input__inner") ||
      el.querySelector(".el-textarea__inner") ||
      el;
    input.addEventListener("compositionstart", () => {
      vnode.locking = true; //解决中文输入双向绑定失效
    });
    input.addEventListener("compositionend", () => {
      vnode.locking = false; //解决中文输入双向绑定失效
      input.dispatchEvent(new Event("input"));
    });
    //输入监听处理
    input.onkeyup = () => {
      if (vnode.locking) {
        return;
      }
      // v-input.num
      if (binding.modifiers.num) {
        //只能输入数字（开头可以多个0）
        onlyNum(input);
      }
      //v-input.num_point
      else if (binding.modifiers.num_point) {
        //只能输入数字+小数点（可以多个小数点）
        onlyNumPoint(input);
      }
      //v-input.float
      else if (binding.modifiers.float) {
        //只能输入浮点型
        onlyFloat(input, binding.value);
      }
      //v-input.float2
      else if (binding.modifiers.float2) {
        //只能输入正负数浮点型
        onlyFloat2(input, binding.value);
      }
      //  v-input.int
      else if (binding.modifiers.int) {
        //只能输入整数（0+正整数）（开头不能多个0）
        onlyInt(input);
      }
      //v-input.intp
      else if (binding.modifiers.intp) {
        //只能输入正整数
        onlyIntp(input);
      }
      //v-input.alp
      else if (binding.modifiers.alp) {
        //只能输入字母
        onlyAlp(input);
      }
      //v-input.num_alp
      else if (binding.modifiers.num_alp) {
        //只能输入数字+字母
        onlyNumAlp(input);
      }
      //v-input.arith
      else if (binding.modifiers.arith) {
        //四则运算符+数字
        onlyArith(input);
      } else if (binding.modifiers.phoneNum) {
        //四则运算符+数字
        phoneNum(input);
      } // v-input.mobileCN
      else if (binding.modifiers.mobileCN) {
        //电话号码
        validateMobileCN(input);
      }
      input.dispatchEvent(new Event("input"));
    };
    /* 合法大陆手机号 */
    function validateMobileCN(input) {
      let value = input.value;
      // 1. 过滤非法字符（只保留数字、横线和括号）
      value = value.replace(/[^\d\-()]/g, "");

      // 2. 限制输入长度
      if (value.length > 15) {
        value = value.slice(0, 15);
      }

      // 3. 更新输入框值
      input.value = value;

      // 4. 获取纯数字版本（去除所有非数字字符）
      const cleanValue = value.replace(/[^\d]/g, "");

      // 5. 实时验证规则
      const isPotentialMobile = /^1[3-9]\d*$/.test(cleanValue); // 可能是手机号
      const isPotentialLandline = /^0\d*$/.test(cleanValue); // 可能是固话

      // 6. 实时反馈逻辑
      if (cleanValue.length === 0) {
        // 空输入状态
        input.style.border = "1px solid #ccc";
      } else if (
        (isPotentialMobile && cleanValue.length <= 11) ||
        (isPotentialLandline && cleanValue.length <= 12)
      ) {
        // 有效格式但可能未完成输入
        if (isPotentialMobile) {
          // const remaining = 11 - cleanValue.length;
          // hint.textContent =
          //   remaining > 0
          //     ? `还需输入${remaining}位手机号数字`
          //     : "✓ 有效的手机号格式";
          // hint.style.color = remaining > 0 ? "#666" : "#4CAF50";
        } else {
          // const minLength =
          //   cleanValue.length <= 4
          //     ? 10 // 区号3-4位+7-8位号码
          //     : cleanValue.length < 10
          //     ? 10
          //     : 0;
          // const remaining = minLength - cleanValue.length;

          // hint.textContent =
          //   remaining > 0
          //     ? `还需输入${remaining}位电话号码数字`
          //     : "✓ 有效的电话号码格式";
          // hint.style.color = remaining > 0 ? "#666" : "#4CAF50";
        }
      } else {
        // 无效格式
        input.style.border = "1px solid #F44336";
        // hint.textContent = "× 无效的电话号码格式";
        // hint.style.color = "#F44336";
      }
      value = value
        .replace("-", "$#$")
        .replace(/\-/g, "")
        .replace("$#$", "-");
      input.value = value;
    }
    //数字
    function onlyNum(input) {
      input.value = input.value.replace(/\D+/g, "");
    }
    //整数(0+正整数)
    function onlyInt(input) {
      let value = input.value;
      value = value.replace(/\D+/g, "");
      input.value = value ? Number(value).toString() : value; //去掉开头多个0
    }
    //正整数
    function onlyIntp(input) {
      if (!/^[1-9][0-9]*$/.test(input.value)) {
        let value = input.value.replace(/\D+/g, "");
        if (value && value.substring(0, 1) === "0") {
          //0开头去除0
          value = value.substring(1);
        }

        input.value = value;
      }
    }

    //数字+小数点
    function onlyNumPoint(input) {
      input.value = input.value.replace(/[^\d.]/g, "");
    }

    //浮点型
    // eslint-disable-next-line no-unused-vars
    function onlyFloat(input, n) {
      let value = input.value;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/^\./g, "");
      value = value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      if (n && Number(n) > 0) {
        //限制n位
        var d = new Array(Number(n)).fill(`\\d`).join("");
        // eslint-disable-next-line no-useless-escape
        var reg = new RegExp(`^(\\-)*(\\d+)\\.(${d}).*$`, "ig");
        value = value.replace(reg, "$1$2.$3");
      }
      if (value && !value.includes(".")) {
        value = Number(value).toString(); //去掉开头多个0
      }
      input.value = value;
    }
    //浮点型 负数
    // eslint-disable-next-line no-unused-vars
    function onlyFloat2(input, n) {
      let value = input.value;
      value = value.replace(/[^-0-9.]/g, "");
      value = value.replace(/^\./g, "");
      value = value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      value = value
        .replace("-", "$#$")
        .replace(/\-/g, "")
        .replace("$#$", "-");
      if (value !== "-") {
        if (n && Number(n) > 0) {
          //限制n位
          var d = new Array(Number(n)).fill(`\\d`).join("");
          // eslint-disable-next-line no-useless-escape
          var reg = new RegExp(`^(\\-)*(\\d+)\\.(${d}).*$`, "ig");
          value = value.replace(reg, "$1$2.$3");
        }
        if (value && !value.includes(".")) {
          value = Number(value).toString(); //去掉开头多个0
        }
      }

      input.value = value;
    }
    //带区号的电话号码
    // eslint-disable-next-line no-unused-vars
    function phoneNum(input) {
      let value = input.value;
      value = value.replace(/[^0-9-]/g, "");
      value = value.replace(/^\-/g, "");
      value = value
        .replace("-", "$#$")
        .replace(/\-/g, "")
        .replace("$#$", "-");
      input.value = value;
    }
    //字母
    function onlyAlp(input) {
      input.value = input.value.replace(/[^A-Za-z]/g, "");
    }
    //数字+字母
    function onlyNumAlp(input) {
      input.value = input.value.replace(/[^A-Za-z0-9]/g, "");
    }

    //四则运算+-*/()数字
    function onlyArith(input) {
      let value = input.value;
      if (value) {
        input.value = value.split("").reduce((prev, cur) => {
          // eslint-disable-next-line no-useless-escape
          if (/^[\d|\-|\+|\*|\/|\.|\(|\)]+$/.test(cur)) {
            return prev + cur;
          }
          return prev;
        }, "");
      }
    }
  }
};
